import { action } from "typesafe-actions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { api } from "../../api/api";
import { IVariant } from "./variants.types";

export const FETCH_VARIANTS_LIST_PROGRESS = "FETCH_VARIANTS_LIST_PROGRESS";
export const FETCH_VARIANTS_LIST_SUCCESS = "FETCH_VARIANTS_LIST_SUCCESS";
export const FETCH_VARIANTS_LIST_FAILED = "FETCH_VARIANTS_LIST_FAILED";

export const fetchVariantsListProgress = () =>
  action(FETCH_VARIANTS_LIST_PROGRESS);
export const fetchVariantsListSuccess = (
  data: IVariant[],
  totalRecords: number
) => action(FETCH_VARIANTS_LIST_SUCCESS, { data, totalRecords });
export const fetchVariantsListFailed = () =>
  action(FETCH_VARIANTS_LIST_FAILED);

export const fetchVariantsListAsync =
  (
    companyOutletUuid: string,
    pageNumber: number,
    itemPerPage: number,
    pageLimit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue?: IDatatableV2AdvancedSearchFilter,
    searchByName?: string,
    variantUuid?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    dispatch(fetchVariantsListProgress());
    try {
      dispatch(saveLoaderProgress());
      let searchQuery = "";

      if (searchByName) {
        searchQuery += `&columns=name&value=${searchByName}`;
      }

      if (variantUuid) {
        searchQuery += `&service_aline_uuid=${variantUuid}`;
      }

      if (searchValue?.length ?? 0) {
        const advanceFilter = [...(searchValue || [])];
        searchQuery += `&advanceFilter=${JSON.stringify(advanceFilter)}`;
      }

      searchQuery += `&from_date=${date.fromDate}&to_date=${date.toDate}`;

      if (status && status !== "-1") {
        searchQuery += `&status=${status}`;
      }

      const response = await api.get(
        `/service/get-service-aline?company_outlet_uuid=${companyOutletUuid}&pageNo=${pageNumber}&pageLimit=${pageLimit}&itemPerPage=${itemPerPage}` +
          searchQuery
      );
      const data: IVariant[] = response.data.data || [];

      const totalRecords = response.data.totalRecords || 0;
      dispatch(fetchVariantsListSuccess(data, totalRecords));
    } catch (error: any) {
      dispatch(fetchVariantsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message:
            error?.response?.data?.message || "Failed to fetch variants",
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const upsertVariantAsync =
  (
    data: IVariant,
    onCallback?: (isSuccess: boolean, data?: IVariant) => void
  ) =>
  async (dispatch: any) => {
    try {
      dispatch(saveLoaderProgress());
      const payload = {
        name: data.name,
        price: data.price,
        description: data.description || "",
        status: data.status,
        service_aline_uuid: data.service_aline_uuid || null,
        company_outlet_uuid: data.company_outlet_uuid,
      };
      const response = await api.post("/service/upsert-service-aline", payload);
      dispatch(saveLoaderCompleted());
      dispatch(
        showMessage({
          type: "success",
          message: data.service_aline_uuid
            ? "Variant updated successfully"
            : "Variant created successfully",
          displayAs: "snackbar",
        })
      );
      onCallback?.(true, response.data.data);
      return response.data.data;
    } catch (error: any) {
      onCallback?.(false);
      dispatch(saveLoaderCompleted());
      dispatch(
        showMessage({
          type: "error",
          message:
            error.response?.data?.message || "Failed to save variant",
          displayAs: "snackbar",
        })
      );
    }
  };

export const CLEAR_VARIANTS_STATE = "CLEAR_VARIANTS_STATE";
export const clearVariantsState = () => action(CLEAR_VARIANTS_STATE);
